exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report {\n  width: 100%;\n}\n.report__wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 0 2rem 0 0;\n}\n.report__item {\n  display: grid;\n  grid-template-columns: repeat(4, 2fr);\n  grid-column-gap: 1rem;\n  background-color: #fff;\n  padding: 10px 20px;\n  border: 1px solid #a7a8aa;\n  margin: 0.5rem 0;\n}\n.report__controls {\n  display: flex;\n  justify-content: flex-end;\n}\n.report__controls img {\n  margin: 0 1rem;\n  cursor: pointer;\n}\n.report__left-side {\n  margin-right: 16px;\n}\n.report__form {\n  padding: 8px 32px;\n}\n.report__form__error {\n  color: #ff3e3e;\n}\n.report__buttons-wrapper {\n  margin-top: 16px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/Report/Report.less
// module id = 1407
// module chunks = 0